import { render, staticRenderFns } from "./MitPasswordForgotPage.vue?vue&type=template&id=1286dc16&scoped=true"
import script from "./MitPasswordForgotPage.vue?vue&type=script&lang=js"
export * from "./MitPasswordForgotPage.vue?vue&type=script&lang=js"
import style0 from "./MitPasswordForgotPage.vue?vue&type=style&index=0&id=1286dc16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1286dc16",
  null
  
)

export default component.exports